module.exports = __webpack_public_path__ + "static/media/Speech bubble (left adjusted).fb5ad88a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wordMark2/Speech bubble (left adjusted).png
// module id = 866
// module chunks = 0